"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["size", "title", "color", "hoverColor", "verticalAlign", "marginRight"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var pencilSvg = function pencilSvg(props) {
  var size = props.size,
    title = props.title,
    color = props.color,
    hoverColor = props.hoverColor,
    verticalAlign = props.verticalAlign,
    marginRight = props.marginRight,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "nonzero",
    d: "M12.999 3.995L3.485 13.51l3.005 3.005L16.005 7 13 3.995zm1.042-1.043l3.007 3.007 1.215-1.215a.9.9 0 0 0 0-1.272l-1.735-1.735a.9.9 0 0 0-1.272 0l-1.215 1.215zM5.32 17.43l-2.75-2.75-.844 3.593 3.594-.843zm-5.3 1.664l1.24-5.287a.737.737 0 0 1 .197-.353L14.214.694a2.374 2.374 0 0 1 3.356 0l1.737 1.736a2.375 2.375 0 0 1-.001 3.355L6.546 18.543a.737.737 0 0 1-.352.196L.906 19.98a.737.737 0 0 1-.886-.885z"
  }));
};
var PencilIcon = (0, _styledComponents["default"])(pencilSvg).attrs(function (props) {
  return {
    hoverColor: props.hoverColor || _constants.colors.darkestGrey,
    size: props.size || '20px',
    verticalAlign: props.verticalAlign || 'text-bottom',
    marginRight: props.marginRight || '0',
    title: props.title || 'edit',
    color: props.color || _constants.colors.mediumGrey
  };
}).withConfig({
  displayName: "pencil__PencilIcon"
})(["vertical-align:", ";margin-right:", ";cursor:pointer;&:hover{path{fill:", ";}}"], function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.marginRight;
}, function (props) {
  return props.hoverColor;
});
PencilIcon.displayName = 'PencilIcon';
var _default = exports["default"] = PencilIcon;